export default __webpack_public_path__ + "static/media/sm_cebu.17c2eb96.png";